import {
  CANCELED_ORDER_FAILURE,
  CANCELED_ORDER_REQUEST,
  DELETE_ORDER_FAILURE,
  DELETE_ORDER_REQUEST,
  DELIVERED_ORDER_FAILURE,
  DELIVERED_ORDER_REQUEST,
  GET_INCOME_FAILURE,
  GET_INCOME_REQUEST,
  GET_INCOME_SUCCESS,
  GET_ORDERS_FAILURE,
  GET_ORDERS_REQUEST,
  GET_ORDERS_SUCCESS,
  GET_RECENT_ORDERS_FAILURE,
  GET_RECENT_ORDERS_REQUEST,
  GET_RECENT_ORDERS_SUCCESS,
  PLACED_ORDER_FAILURE,
  PLACED_ORDER_REQUEST,
  SHIP_ORDER_FAILURE,
  SHIP_ORDER_REQUEST,
  GET_ORDER_STATS_FAILURE,
  GET_ORDER_STATS_REQUEST,
  GET_ORDER_STATS_SUCCESS,
  ADD_PENALTY_REQUEST,
  ADD_PENALTY_FAILURE,
  ASSIGN_EMPLOYEE_BY_ADMIN_REQUEST,
  ASSIGN_EMPLOYEE_BY_ADMIN_FAILURE
} from "./ActionType";

const initialState = {
  loading: false,
  orders: [],
  recentOrders: [],
  orderStats: null,
  income: null,
  error: ""
};

const adminOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDERS_REQUEST:
    case GET_RECENT_ORDERS_REQUEST:
      return { ...state, loading: true };

    case GET_ORDERS_SUCCESS:
      return { ...state, loading: false, orders: action.payload, error: "" };

    case GET_RECENT_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        recentOrders: action.payload,
        error: ""
      };

    case GET_ORDERS_FAILURE:
    case GET_RECENT_ORDERS_FAILURE:
      return { ...state, loading: false, orders: [], error: action.payload };

    case GET_INCOME_REQUEST:
      return { ...state, loading: true };

    case GET_INCOME_SUCCESS:
      return { ...state, loading: false, income: action.payload, error: "" };

    case GET_INCOME_FAILURE:
      return { ...state, loading: false, income: null, error: action.payload };

    case GET_ORDER_STATS_REQUEST:
      return { ...state, loading: true };

    case GET_ORDER_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        orderStats: action.payload,
        error: ""
      };

    case GET_ORDER_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        orderStats: null,
        error: action.payload
      };

    case PLACED_ORDER_REQUEST:
    case DELIVERED_ORDER_REQUEST:
    case CANCELED_ORDER_REQUEST:
    case SHIP_ORDER_REQUEST:
    case ADD_PENALTY_REQUEST:
    case ASSIGN_EMPLOYEE_BY_ADMIN_REQUEST:
      return { ...state, loading: true, error: "" };

    case PLACED_ORDER_FAILURE:
    case DELIVERED_ORDER_FAILURE:
    case CANCELED_ORDER_FAILURE:
    case SHIP_ORDER_FAILURE:
    case ADD_PENALTY_FAILURE:
    case ASSIGN_EMPLOYEE_BY_ADMIN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_ORDER_REQUEST:
      return { ...state, loading: true, error: "" };

    case DELETE_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
export default adminOrderReducer